var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Latest Lesson")]),_c('LessonVideo',{attrs:{"videoSource":_vm.getMostRecent().videoName,"notes":_vm.getMostRecent().notes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }